import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({staticClass:"my-3"},'div',_vm.$attrs,false),[_c(VSkeletonLoader,{attrs:{"type":"text","width":"25%"}}),_c(VSkeletonLoader,{attrs:{"type":"text"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }